import TableRow from 'emerald-ui/lib/TableRow';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: TableRow, componentName: 'TableRow' }], 'TableRow'),
  description: 'A table row with selection features.',
  codeSamples: [
    {
      title: 'Default',
      scope: { TableRow },
      code: `<div style={{ overflow: 'auto' }}>
  <table className="eui-table">
    <tbody>
      <TableRow checkboxAriaLabel="Mark Weaver">
        <td>Mark Weaver</td>
        <td>Marketing Assistant</td>
        <td>Sports</td>
      </TableRow>
    </tbody>
  </table>
</div>`,
    },
  ],
};
